import React from 'react';
import './styles.scss';
import kris from '../../images/about-kris.jpg';
import karol from '../../images/about-karol.jpg';
import kamil from '../../images/about-kamil.jpg';
import mateusz from '../../images/about-mateusz.jpg';
import noPhoto from '../../images/about-no-photo.png';


const members = [{
  avatar: kris,
  name: 'Kris',
  text: 'Właściciel i kierownik artystyczny. Od najmłodszych lat związany ze sceną zjadł zęby na eventach, co dało ogromne rozeznanie w potrzebach klienta. Dziś to właśnie dzięki jego charyzmie i doświadczeniu, ale przede wszystkim pozytywnemu nastawieniu agencja realizuje nietypowe, szyte na miarę zlecenia i cieszy się co raz większym zaufaniem klientów.'
}, {
  avatar: karol,
  name: 'Karol',
  text: '"Szara eminencja". Łącznik i "bezpiecznik" między artystami, a klientem. Koordynator, który z właściwym sobie poczuciem humoru, pilnuje by wszystko szło zgodnie z planem. Spotkasz go przy realizatorze albo w lewym sektorze garderoby, a prywatnie w 229 polskich kinach studyjnych i lokalnych.'
}, {
  avatar: kamil,
  name: 'Kamil',
  text: 'Kiedy jest już wspaniała wizja i są najlepsi artyści, musi być doskonała technika, bo tylko zestawienie tych trzech czynników składa się na sukces. Kamil jak nikt inny dobiera sprzęt do potrzeb imprezy i odpowiada  za wszystko co gra, huczy i błyszczy.'
},  {
  avatar: mateusz,
  name: 'Mateusz',
  text: 'Muzyka to nie tylko artysta, jego twórczość i wykonanie. Najpiękniejsze dźwięki nie zrobią na nikim wrażenia, jeśli nie będą dobrze nagłośnione. Mateusz to jeden z najlepszych w branży specjalistów od dźwięku, a do tego najbardziej pozytywna osoba jaką można sobie wyobrazić.'
}]


const Member = (props) => {
  return (
    <div className="about-member">
      <div className="about-member__left">
        <img src={`${props.avatar}`} className="about-member__image" alt={props.name} />
      </div>
      <div className="about-member__right">
        <h4 className="about-member__title">{props.name}</h4>
        <p className="about-member__content">{props.text}</p>
      </div>
    </div>
  );
}

const AboutMembers = () => {
  return ( 
    <div className="about-members">
      <ul className="about-members__list">
        {members.map((member, index) => (
          <li className="about-members__element" key={index}>
            <Member name={member.name} text={member.text} avatar={member.avatar}/>
          </li>
        ))}
      </ul>
    </div>
  )
};

export default AboutMembers;



// WEBPACK FOOTER //
// ./src/components/AboutMembers/index.js